import React, { useEffect } from 'react';

import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';
import {
  safeStringify,
  wrapWithEventPropertiesPrefix,
} from '@adsk/exo-skeleton-api/internal';

import { AnnouncementBanner } from './AnnouncementBanner';
import { EXO_SKELETON_SCOPE_NAME } from '../../consts';
import {
  ANNOUNCEMENT_BANNER_REPORT_TYPES,
  Announcement,
} from '../../hooks/useAnnouncment';
import { useLiveFeatureFlag } from '../LaunchDarklyProvider';

export const ConnectedAnnouncementBanner = () => {
  const { value: announcementBannerDetails } = useLiveFeatureFlag<
    Partial<Announcement>
  >('announcement-banner-details', {});

  useEffect(() => {
    if (announcementBannerDetails) {
      const {
        text,
        startDate,
        endDate,
        userAgentRegex,
        allowDismiss,
        ...otherProps
      } = announcementBannerDetails;

      if (Object.keys(otherProps).length > 0) {
        const context = {
          unknownFields: otherProps,
        };

        report({
          scope: EXO_SKELETON_SCOPE_NAME,
          type: REPORT_TYPES.warning,
          value:
            ANNOUNCEMENT_BANNER_REPORT_TYPES.UNKNOWN_FIELDS_IN_FEATURE_FLAG,
          context: {
            ...context,
            ...wrapWithEventPropertiesPrefix({
              data: safeStringify(context),
              type: REPORT_TYPES.warning,
              message:
                ANNOUNCEMENT_BANNER_REPORT_TYPES.UNKNOWN_FIELDS_IN_FEATURE_FLAG,
            }),
          },
        });
      }
    }
  });

  if (
    !announcementBannerDetails ||
    Object.keys(announcementBannerDetails).length === 0
  ) {
    return null;
  }

  return <AnnouncementBanner {...announcementBannerDetails} />;
};
